import { createSelector } from 'reselect';

const intPaymentConfigSelector = (state) => state.intPayments;

export const selectAccounts = createSelector(
  [intPaymentConfigSelector],
  (intPayment) => intPayment.stripeAccount
);

export const selectSavingAccount = createSelector(
  [intPaymentConfigSelector],
  (intPayment) => intPayment.saving
);

export const selectLoadingAccount = createSelector(
  [intPaymentConfigSelector],
  (intPayment) => intPayment.loading
);